<div class="header" id="authorization-status-by-region-or-forest-heading"><h3>AUTHORIZATION STATUS BY @if(this.summaryInfoRegion()){REGION} @else {FOREST}</h3></div>
<table
  mat-table [dataSource]="summaryData" class="center"
  matSort matSortDisableClear
  aria-labelledby="authorization-status-by-region-or-forest-heading authorization-status-by-region-or-forest-caption"
>
    <caption id="authorization-status-by-region-or-forest-caption" class="usa-sr-only">
      AUTHORIZATION STATUS BY @if(this.summaryInfoRegion()){REGION} @else {FOREST}
    </caption>
    <ng-container matColumnDef="region">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Region</th>
        <td mat-cell *matCellDef="let data"><button type="button" class="link-like" (click)="changeFilter('region',data.region)" [attr.aria-label]="'region-' + data.region">{{data.region}}</button></td>
    </ng-container>
    <ng-container matColumnDef="forest_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Forest</th>
        <td mat-cell *matCellDef="let data"><button type="button" class="link-like" (click)="changeFilter('forest',data.forest_name)" [attr.aria-label]="'forest-' + data.forest_name">{{data.forest_name}}</button></td>
    </ng-container>
    <ng-container matColumnDef="fire_count">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>BAER Wildfires</th>
        <td mat-cell *matCellDef="let data">{{data.fire_count ?? 0 | number:'1.0-2'}}</td>
    </ng-container>
    <ng-container matColumnDef="nfs_acres">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>NFS Acres</th>
        <td mat-cell *matCellDef="let data">{{data.nfs_acres ?? 0 | number:'1.0-2'}}</td>
    </ng-container>
    <ng-container matColumnDef="fire_acres">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Acres</th>
        <td mat-cell *matCellDef="let data">{{data.fire_acres ?? 0 | number:'1.0-2'}}</td>
    </ng-container>
    <ng-container matColumnDef="total_req">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="align-right">Total Requested</th>
        <td mat-cell *matCellDef="let data" class="align-right">{{'$'+(data.total_req ?? 0 | number:'1.2-2') | empty_check}}</td>
    </ng-container>
    <ng-container matColumnDef="ro_auth">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="align-right">RO Authorized</th>
        <td mat-cell *matCellDef="let data" class="align-right">{{'$'+(data.ro_auth ?? 0 | number:'1.2-2') | empty_check}}</td>
    </ng-container>
    <ng-container matColumnDef="wo_auth">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="align-right">WO Authorized</th>
        <td mat-cell *matCellDef="let data" class="align-right">{{'$'+(data.wo_auth ?? 0 | number:'1.2-2') | empty_check}}</td>
    </ng-container>
    <ng-container matColumnDef="total_auth">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="align-right green">Total Authorized</th>
        <td mat-cell *matCellDef="let data" class="align-right green">{{'$'+(data.total_auth ?? 0 | number:'1.2-2') | empty_check}}</td>
    </ng-container>
    <!-- <ng-container matColumnDef="total_exp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="green">Total Expended</th>
        <td mat-cell *matCellDef="let data" class="align-right green">{{'$'+('200' ?? 0 | number:'1.2-2') | empty_check}}</td>
    </ng-container>
    <ng-container matColumnDef="exp_percent">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="green">Expenditures (%)</th>
        <td mat-cell *matCellDef="let data" class="align-right green">50%</td>
    </ng-container> -->

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"></tr>
</table>
